import { Link } from 'react-router-dom';

interface EmptyStateProps {
  icon?: string;
  title: string;
  description?: string;
  actionLabel?: string;
  onAction?: () => void;
  actionTo?: string;
}

export default function EmptyState({
  icon = 'ri-inbox-archive-line',
  title,
  description,
  actionLabel,
  onAction,
  actionTo,
}: EmptyStateProps) {
  return (
    <div className="flex flex-col items-center justify-center rounded-xl border border-dashed border-background-300/70 bg-background-100/60 px-6 py-16 text-center">
      <span className="mb-4 flex h-16 w-16 items-center justify-center rounded-full bg-background-200 text-foreground-400">
        <i className={`${icon} text-3xl`} />
      </span>
      <p className="font-heading text-base font-semibold text-foreground-900">{title}</p>
      {description && (
        <p className="mt-2 max-w-sm text-sm leading-relaxed text-foreground-500">{description}</p>
      )}
      {actionLabel && onAction && (
        <button
          type="button"
          onClick={onAction}
          className="mt-5 rounded-full bg-primary-500 px-6 py-2.5 text-sm font-semibold text-foreground-950 transition-colors hover:bg-primary-400"
        >
          {actionLabel}
        </button>
      )}
      {actionLabel && actionTo && (
        <Link
          to={actionTo}
          className="mt-5 rounded-full bg-primary-500 px-6 py-2.5 text-sm font-semibold text-foreground-950 transition-colors hover:bg-primary-400"
        >
          {actionLabel}
        </Link>
      )}
    </div>
  );
}